import { getRequest } from "api/tools/httpRequests";
import React from "react";

function useFetchTourOptions() {
  const [tourOptions, setTourOptions] = React.useState([]);
  const [regex, setRegex] = React.useState("");

  React.useEffect(() => {
    const timeout = setTimeout(async () => {
      const response = await getRequest(
        `areas/findTourOptions?regex=${regex}`,
        {}
      );

      if (response?.data?.success) {
        const tailoredData = response.data.result.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        setTourOptions(tailoredData);
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [regex]);

  return {
    tourOptions,
    setRegex,
    regex,
  };
}
export default useFetchTourOptions;
